export const HOSTED_DOMAIN = "labs.cascadeenergy.com";
